<script setup lang="ts">
import { Vue3Lottie } from 'vue3-lottie';
import LoadingIndicator from '@/assets/animations/LoadingIndicator.json';
import { onBeforeUnmount, useTemplateRef } from 'vue';

const lottieRef = useTemplateRef('lottie');
onBeforeUnmount(() => {
  lottieRef.value?.stop();
  lottieRef.value?.destroy();
});
</script>

<template>
  <div class="fixed inset-0 z-50 flex items-center justify-center bg-surface-secondary/50">
    <Vue3Lottie
      ref="lottie"
      :animation-data="LoadingIndicator"
      :loop="true"
      :autoplay="true"
      :renderer-settings="{ preserveAspectRatio: 'xMidYMid meet' }"
      :height="48"
      :width="48"
      class="pointer-events-none"
    />
  </div>
</template>
